import React, { useState, useEffect } from 'react';
import Carousel from 'react-material-ui-carousel';
import { Box, Container, Grow, Grid, Typography, Tabs, Tab, Button, Paper } from '@material-ui/core';
// import { Pagination, PaginationItem } from '@material-ui/lab'
// import { getPostsBySearch } from '../../actions/posts';
// import { useDispatch } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
// import ChipInput from 'material-ui-chip-input';

// import Posts from '../Posts/Posts';
// import Form from '../Form/Form';
import SliderTab from './../Landing/SliderTab/SliderTab';
// import Footer from '../Footer/Footer';
import useStyles from './styles';
import illustration from '../../assets/others/flare_illustration.png';
import AGB_img from '../../assets/support company/AGB.png';
import ICHIGO_img from '../../assets/support company/ICHIGO.png';
import event_img from '../../assets/others/event.png';
import ProjectCarousel from './ProjectCarousel/ProjectCarousel';
import ProjectRecommend from './ProjectRecommend/ProjectRecommend';
import EventCarousel from './EventCarousel/EventCarousel';
import useCommonStyles from '.././CommonStyle/commonStyle';
import question_icon from '../../assets/logo/question_icon.png';
import GoToTop from '../Functional/GoToTop';
import { getProjectsBySearch, getProjects } from '../../actions/projects';
import { useDispatch } from 'react-redux';


// import { classes } from 'istanbul-lib-coverage';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const Dashboard = () => {

    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const dispatch = useDispatch();
    console.log("---Dashboard Called");


    return (
        <Grow in>
            <Container maxWidth="lg">
                <Grid container direction="row" justifyContent="center" spacing={10} className={classes.projectsGridContainer}>
                    {/* <Grid direction="column" item sm={12} md={4} className={classes.leftGrid}>

                    </Grid> */}
                    <Grid container justifyContent="center" item sm={12} md={10} className={classes.rightGrid}>
                        <Grid container direction="column" justifyContent="center" item className={classes.rightupGrid}>
                            <Typography component={'span'} variant="h5"  >
                                <br />今日のおすすめ
                            </Typography><br />
                            <Grid container justifyContent="center" item className={classes.projectRecommendation}>
                                <Grid sm={12} md={7}>
                                    <ProjectRecommend /></Grid>
                                <Grid container justifyContent="center" alignContent="center" sm={12} md={4}>
                                    <Button component={Link} to="/projects" className={classes.viewProjects} variant="contained" color="primary" size="large" type="submit" fullWidth>プロジェクト一覧</Button>
                                </Grid>

                            </Grid>

                        </Grid>
                        <Grid container justifyContent="center" item className={classes.rightdownGrid}>
                            <img src={event_img} height="170" />
                        </Grid>
                    </Grid>

                </Grid>
                <Grid container direction="column" className={classes.carouselsGrid} justifyContent="center">
                    {/* <Grid><div className={classes.carouselTitle}>今日のおすすめ</div></Grid> */}

                    <Container className={classes.projectsGridContainer}>
                        {/* <Carousell /> */}
                        <Typography component={'span'} className={classes.sectionTitle} >
                            NEWS
                        </Typography>
                        <br />
                        <br />
                        <br />
                        <ProjectCarousel />

                    </Container>
                </Grid>
                <div className={classes.sliderTab}>
                    <Typography component={'span'} className={classes.sectionTitle} >
                        HOW TO USE
                    </Typography>
                    <br />
                    <br />
                    <br />
                    <SliderTab />
                </div>
                <Typography component={'span'} variant="h5" className={commonClasses.sectionOrangeTitle} >
                    Q&A<br />
                </Typography>
                <Grid item xs={12} sm={12} md={12} className={commonClasses.QA}>
                    <QA question='参加費用はかかりますか？' answer='全て無料です。' />
                    <QA question='中学生でも参加できますか？' answer='はい！私たちは中学生から20歳以下のZ世代の皆さんをお待ちしています。' />
                    <QA question='運営を行っているのはどのような団体ですか？' answer='一般社団法人Sustainable Gameが非営利で活動しています。詳細はこちらからご覧ください。 https://www.sustainablegame.com/' />
                    <QA question='1人でも参加可能ですか？' answer='はい！大丈夫です。担当のコミュニケーターが手厚くサポートします。' />
                </Grid>
                <GoToTop />
            </Container>
            {/* <Footer /> */}
        </Grow>
    )
    function QA(props: { question: string; answer: string; }) {
        return <><div className={commonClasses.questionDiv}>
            <img src={question_icon} alt="question_icon" className={commonClasses.questionIcon} />
            <Typography className={commonClasses.questionText}>
                {props.question}
            </Typography>
        </div><div className={commonClasses.answerDiv}>
                <Typography className={commonClasses.answerIcon}>
                    A.
                </Typography>
                <Typography>
                    {props.answer}
                </Typography>
            </div></>;
    }
};

export default Dashboard;